export const regexTextPreValidation = /[^a-zA-ZñÑ0-9áéíóúÁÉÍÓÚ'°"“”‘’–—…₀₁₂₃₄₅₆₇₈₉⁰¹²³⁴⁵⁶⁷⁸⁹,.()/\[\]#->!+@$_&*:;?%<¿¡©®™~=^-|\n ]/g;

export const regexTextValidation = /^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°"“”,.()0-9/\[\]#->!+@$_&*:;?%<¿¡©®™~=^-|\n ]+$/;

export const regexTextValidationPassword = /^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°,.()0-9/\[\]#->!+@$_&*:;?%<¿¡~=^-|]+$/;
